import { SdkContext } from '../internal'

/** What `GET /api/exports/{exportId}/download` answers: a signed link that lives five minutes. */
export interface ExportDownload {
  url: string
  urlExpiresAt?: string
  expiresAt?: string
  fileName?: string
  kind?: string
}

/** SEC-216: big exports, generated by the queue and e-mailed as a link to `/_/exports/{id}`. */
export class ExportsResource {
  constructor(private ctx: SdkContext) {}

  /** Requester only, role checked again; 404 (not theirs or gone), 409 (still generating), 410 (expired). */
  async download(exportId: string): Promise<ExportDownload> {
    return this.ctx.call({ httpMethod: 'GET', path: '/exports/{exportId}/download' }, { exportId })
  }
}
